import { useEffect } from "react";
import { fetch } from "@/lib/api";

/**
 * Checks backend health by calling the /health endpoint.
 * Uses VITE_BACKEND_URL for direct backend access.
 */
export async function checkBackendHealth(
  _apiUrl?: string,
  apiKey: string | null = null,
): Promise<boolean> {
  try {
    const res = await fetch("/health", {
      method: "GET",
      skipContentType: true,
      ...(apiKey && {
        headers: {
          "X-Api-Key": apiKey,
        },
      }),
    });

    return res.ok;
  } catch (e) {
    console.error("Health check failed:", e);
    return false;
  }
}

/**
 * Hook to perform a fire-and-forget health check on mount
 * This triggers backend cold start early in the app lifecycle
 */
export function useHealthCheck(_apiUrl?: string, apiKey: string | null = null) {
  useEffect(() => {
    // Fire-and-forget health check to wake up the backend
    checkBackendHealth(undefined, apiKey).then((isHealthy) => {
      if (!isHealthy) {
        console.warn("Backend health check failed - backend may be starting");
      }
    });
  }, [apiKey]);
}
